import { render, staticRenderFns } from "./ShiftDetailDialog.vue?vue&type=template&id=0c598127&"
import script from "./ShiftDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ShiftDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports